import { render, staticRenderFns } from "./LobbyBox.vue?vue&type=template&id=3445121d&scoped=true&"
import script from "./LobbyBox.vue?vue&type=script&lang=js&"
export * from "./LobbyBox.vue?vue&type=script&lang=js&"
import style0 from "./LobbyBox.vue?vue&type=style&index=0&id=3445121d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445121d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/is_minesweeper-flags-client_main/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VToolbar,VToolbarTitle})
